var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogZegar = function SvgBlogZegar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 96,
    width: 96,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 4C23.7 4 4 23.7 4 48c0 24.301 19.7 44 44 44 24.301 0 44-19.699 44-44C92 23.7 72.301 4 48 4zm0 80c-19.882 0-36-16.118-36-36s16.118-36 36-36 36 16.118 36 36-16.118 36-36 36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46.343V24a4 4 0 0 0-8 0v24l.003.027c.001.253.026.506.076.755.024.123.069.234.104.354.039.132.069.266.122.395.058.138.136.264.208.394.054.1.097.2.16.295.147.221.314.428.501.613l11.311 11.312a4 4 0 1 0 5.658-5.656L52 46.343z"
  })));
};
export default SvgBlogZegar;